import styled from 'styled-components'
import { mildBlue, blue, inputShadow } from '../../styles/variables.js'

const Translates = styled.div`
  min-width: 500px;
  display: flex;
  flex-direction: column;
  min-height: 55vh;
  max-height: 55vh;
`

const LibraryItem = styled.div`
  box-shadow: ${inputShadow};
  padding: 10px;
  margin-bottom: 5px;
  cursor: pointer;
  background: white;
  &:hover {
    background: ${mildBlue};
  }

  ${({ selected }) => selected ? `
    background: ${blue};
    color: white;
    &:hover {
      background: ${blue};
    }
  `: ''}
`

const Library = styled.div`
  flex: 1 1;
  min-width: 500px;
  display: flex;
  flex-direction: column;
  min-height: 55vh;
  max-height: 55vh;
`

const LibraryList = styled.div`
  flex: 1 1;
  overflow: auto;
  padding: 1px;
`

export default {
  Translates,
  LibraryItem,
  Library,
  LibraryList,
}
